<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canViewVerticalNavMenuLink(_vm.item)
    ? _c(
        "li",
        {
          staticClass: "nav-item menu-item-coin",
          class: {
            active: _vm.isActive,
            disabled: _vm.item.disabled,
          },
        },
        [
          _c(
            "b-link",
            _vm._b(
              { staticClass: "d-flex align-items-center menu-txt-outer" },
              "b-link",
              _vm.linkProps,
              false
            ),
            [
              _c(
                "span",
                { staticClass: "icon-span" },
                [
                  _c("feather-icon", {
                    attrs: { icon: _vm.item.icon || "CircleIcon" },
                  }),
                  _vm.item.icon == "Payment"
                    ? _c("Payment", { staticClass: "custom-icon" })
                    : _vm._e(),
                  _vm.item.icon == "Security"
                    ? _c("Security", { staticClass: "custom-icon" })
                    : _vm._e(),
                  _vm.item.icon == "Verification"
                    ? _c("Verification", { staticClass: "custom-icon" })
                    : _vm._e(),
                  _vm.item.icon == "Wallet"
                    ? _c("Wallet", { staticClass: "custom-icon" })
                    : _vm._e(),
                  _vm.item.icon == "Order"
                    ? _c("Order", { staticClass: "custom-icon" })
                    : _vm._e(),
                  _vm.item.icon == "BuySell"
                    ? _c("BuySell", { staticClass: "custom-icon buy-sell" })
                    : _vm._e(),
                  _vm.item.icon == "MyAds"
                    ? _c("MyAds", { staticClass: "custom-icon" })
                    : _vm._e(),
                ],
                1
              ),
              _c("span", { staticClass: "menu-title text-truncate menu-txt" }, [
                _vm._v(_vm._s(_vm.t(_vm.item.title))),
              ]),
              _vm.item.tag
                ? _c(
                    "b-badge",
                    {
                      staticClass: "mr-1 ml-auto",
                      attrs: {
                        pill: "",
                        variant: _vm.item.tagVariant || "primary",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.item.tag) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-link/VerticalNavMenuLink.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_libs_acl from '@core/libs/acl';
import * as bootstrapvue from 'bootstrap-vue';
import core_libs_i18n from '@core/libs/i18n';
import useVerticalNavMenuLink from './useVerticalNavMenuLink';
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink';
import assets_rashi_coin_payment_svg from '@/assets/rashi-coin/payment.svg';
import assets_rashi_coin_security_svg from '@/assets/rashi-coin/security.svg';
import assets_rashi_coin_verification_svg from '@/assets/rashi-coin/verification.svg';
import assets_rashi_coin_wallet_svg from '@/assets/rashi-coin/wallet.svg';
import assets_rashi_coin_order_svg from '@/assets/rashi-coin/order.svg';
import assets_rashi_coin_buysell_svg from '@/assets/rashi-coin/buysell.svg';
import assets_rashi_coin_myads_svg from '@/assets/rashi-coin/myads.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BBadge: bootstrapvue["BBadge"],
    Payment: assets_rashi_coin_payment_svg,
    Security: assets_rashi_coin_security_svg,
    Verification: assets_rashi_coin_verification_svg,
    Wallet: assets_rashi_coin_wallet_svg,
    Order: assets_rashi_coin_order_svg,
    BuySell: assets_rashi_coin_buysell_svg,
    MyAds: assets_rashi_coin_myads_svg
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      isActive,
      linkProps,
      updateIsActive
    } = useVerticalNavMenuLink(props.item);
    const {
      t
    } = core_libs_i18n.useUtils();
    const {
      canViewVerticalNavMenuLink
    } = core_libs_acl.useUtils();
    return {
      isActive,
      linkProps,
      updateIsActive,
      // ACL
      canViewVerticalNavMenuLink,
      // i18n
      t
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-link/VerticalNavMenuLink.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.active .fees path,
.active .refdata path {
  fill: #fff;
}
.active .buy-sell path {
  stroke: #fff;
}
</style>
